import React from "react";
import check from '../images/check.gif'
import btnHome from '../images/btnHomeIcon.png'
import { Printer } from 'tabler-icons-react';
import bedIcon from '../images/iconSelect1.png';

const SuccessReg = () => {
  return (
    <div className="topicSection">

      {/* HOME BUTTON SECTION */}
      <div className="btnHomeSection bounce-in-fwd10">
        <button type="button" className="btnCircle">
          <img src={btnHome} alt="Date" height="50" width="50" /><br />
          HOME
        </button>
      </div>

      <div className="headerSub">
        <div className="headerSubTitle TextBig fcolorGreen scale-in-center">
          <p>
            REGISTRATION SUCCESSFUL
          </p>
        </div>
      </div>

      <div className="headerName">
        <div className="headerTitle">
          {/* <h1>
            <div className="iconWard"></div>
            xxxxx
            </h1> */}
        </div>
      </div>


      {/* MAIN CONTENT SECTION */}
      <div className="contentPage">

        <div className="messageInfoTop3 fade-in-left3">
          <p>
            You have registered to,
          </p>
        </div>
        <div className="clearboth"></div>

        {/* BOX SECTION  */}
        <div className="boxSectionSuccess">
          <div className="vBoxMainSuccess scale-in-center8">
            <div className="vNumberMainSuccess">
              <img src={bedIcon} alt="choose" height="60" width="60" /> 
              <span>WARD VISITOR</span>
            </div>
            <div className="vInfoMainSuccess">
              <p>
                WARD: 11C <br />
                BED: 21
              </p>
            </div>
          </div>
        </div>

        <div className="clearboth"></div>
        <div className="messageInfoBottom3 fade-in-left7">
          <p>
            Please proceed to ...
          </p>
        </div>




        <div className="iconBtnCorner fde-in-left9">
          <Printer size={50} strokeWidth={2} color={'white'} />
        </div>


        <div className="clearboth"></div>
        {/* ICON BOX */}
        <div className="iconSection2 iconCenter flip-in-hor-top2">
          <img className="fade-in3" src={check} alt="check" height="600" width="600" />
        </div>

      </div>

    </div>
  );
}

export default SuccessReg;